import { render, staticRenderFns } from "./ManageDiscount.vue?vue&type=template&id=50f920d0"
import script from "./ManageDiscount.vue?vue&type=script&lang=ts"
export * from "./ManageDiscount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports